import palette from '@lib/core/src/theme/palette';
import { alpha, Divider, Stack, styled, Typography } from '@mui/material';

export const EVENT_HEIGHT = '48px';

export const EventContainer = styled(Stack, {
  shouldForwardProp: prop => prop !== 'passed'
})<{ passed: boolean }>(({ passed }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  ':hover': {
    backgroundColor: passed ? palette.grey[900] : palette.grey[800]
  },
  alignItems: 'center',
  padding: '8px 16px',
  height: EVENT_HEIGHT,
  backgroundColor: passed ? palette.grey[800] : palette.white,

  borderBottom: `1px solid ${palette.grey[100]}`
}));

export const EventDetails = styled(Stack)(() => ({
  alignItems: 'start',
  opacity: 0.9,
  cursor: 'pointer',
  ':hover': { boxShadow: `0px 0px 4px ${alpha(palette.grey[500], 0.2)}` },
  minWidth: '300px',
  justifyContent: 'space-between',
  borderRadius: '8px',
  padding: '12px',
  gap: '3px'
}));

export const EventTitle = styled(Typography)({
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '16px',
  maxWidth: '250px',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis'
});

export const EventTime = styled(Typography)({
  fontSize: '11px',
  fontWeight: 500,
  lineHeight: '14px'
});

export const EventStripe = styled(Divider)({
  width: '2px',
  borderRadius: '5px',
  height: '24px'
});

export const PrepareButton = styled(Stack)(() => ({
  padding: '8px 12px',
  height: '24px',
  justifyContent: 'center',
  gap: '6px',
  alignItems: 'center',
  cursor: 'pointer',
  borderRadius: '12px',
  backgroundColor: palette.black,
  color: palette.white,
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '16px'
}));

export const ViewButton = styled(Stack)(() => ({
  padding: '8px 12px',
  height: '24px',
  justifyContent: 'center',
  gap: '6px',
  alignItems: 'center',
  cursor: 'pointer',
  borderRadius: '12px',
  border: `1px solid ${palette.grey[500]}`,
  backgroundColor: palette.white,
  color: palette.black,
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '16px'
}));
